import { Injectable } from '@angular/core';
import { Registermodel } from './registermodel';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Result } from 'src/app/shared/result';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private http: HttpClient) { }

  public NewRegister(data: Registermodel) {
    return this.http.post<any>(`${environment.apiUrl}/Login/GetRegistrationDetails`, data)
  }

  public getOTP(data: Registermodel) {
    //data.EmailID=data.MobileNo;
    return this.http.post<Result>(`${environment.apiUrl}/Login/CheckOTP`, data)
  }
}
